import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';

const PrivacyPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO 
        title={t('privacy.title')}
        url="https://band-space.com/privacy/"
        canonical="https://band-space.com/privacy/"
      />
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            {t('privacy.title', 'Privacy Policy')}
          </Typography>
          
          <Box sx={{ mt: 4 }}>
            <Typography variant="h6" gutterBottom>
              {t('privacy.lastUpdated', 'Last Updated: March 2024')}
            </Typography>

            <Typography variant="body1" paragraph>
              {t('privacy.introduction', 'At Band Space, we take your privacy seriously. This policy describes how we collect, use, and protect your personal information.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('privacy.collection', '1. Information We Collect')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('privacy.collectionContent', 'We collect information you provide directly to us, including your name, email address, phone number, and payment information. We also collect information about your use of our services.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('privacy.use', '2. How We Use Your Information')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('privacy.useContent', 'We use your information to provide and improve our services, process your bookings, communicate with you, and ensure the security of our platform.')}
            </Typography>

            {/* 🔹 New Section 2A - Calendar Integration */}
            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('privacy.calendarIntegration', '2A. Google Calendar Integration')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t(
                'privacy.calendarIntegrationContent',
                'If you choose to connect your Google Calendar account to Band Space, we request permission to create and manage calendar events on your behalf using the Google Calendar API. We only access and manage calendar events related to your rehearsal bookings. We do not access or store unrelated calendar data, and we do not share your calendar information with third parties. You can revoke access at any time through your Google Account settings.'
              )}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('privacy.sharing', '3. Information Sharing')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('privacy.sharingContent', 'We share your information with space owners and service providers as necessary to fulfill your bookings. We do not sell your personal information to third parties.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('privacy.cookies', '4. Cookies and Tracking')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('privacy.cookiesContent', 'We use cookies and similar technologies to improve your experience and analyze how you use our platform. You can control cookie settings through your browser preferences.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('privacy.security', '5. Data Security')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('privacy.securityContent', 'We implement appropriate security measures to protect your personal information from unauthorized access, alteration, or disclosure.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('privacy.rights', '6. Your Rights')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('privacy.rightsContent', 'You have the right to access, correct, or delete your personal information. You can also opt out of marketing communications at any time.')}
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
              {t('privacy.contact', '7. Contact Us')}
            </Typography>
            <Typography variant="body1" paragraph>
              {t('privacy.contactContent', 'If you have questions about this privacy policy or our data practices, please contact us at privacy@bandspace.com')}
            </Typography>
          </Box>
        </Paper>
      </Container>
    </>
  );
};

export default PrivacyPage;
